import actions from '../../actionTypes';

export default (siteId, loadChildren, account, ignoreFile) => {
  return {
    type: actions.GET_AREAS,
    siteId,
    loadChildren,
    account,
    ignoreFile
  };
};



// WEBPACK FOOTER //
// ./src/reducers/areas/actions/getAreas.js